import React, { FC } from 'react';

import { getActualDateTimeFormat, getRelativeDateFormat } from '@utils/utils';

import { useAppSelector } from '@hooks/redux';

import { IEnvelopeLastChangeProps as IProps } from '@views/envelopes/types';

const EnvelopLastChange: FC<IProps> = ({ lastActionDateTime }) => {
  const { language } = useAppSelector(state => state.utils)

  const relativeDate = getRelativeDateFormat(lastActionDateTime, language)
  const actualDateTime = getActualDateTimeFormat(lastActionDateTime, language)

  return (
    <td title={actualDateTime}>
      {relativeDate}
    </td>
  )
}

export default EnvelopLastChange
